module.exports = __webpack_public_path__ + "static/media/wordmark.3cfe8d08.svg";